<template>
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8276 7.04374C12.9993 7.12788 13.0516 7.30523 12.9442 7.43986C12.6223 7.84374 12.2397 8.21114 11.8048 8.53115L12.6856 9.22166C12.8287 9.33391 12.8287 9.51593 12.6856 9.62822C12.5423 9.74044 12.3102 9.74044 12.167 9.62822L11.2408 8.90205C10.657 9.24395 9.99986 9.508 9.28475 9.6741L9.6142 10.6381C9.66656 10.7914 9.55048 10.949 9.3549 10.9901C9.15929 11.0312 8.95824 10.9402 8.90583 10.7869L8.57006 9.80432C8.22412 9.8506 7.86693 9.87469 7.50001 9.87469C7.13308 9.87469 6.77589 9.8506 6.42994 9.80432L6.09419 10.7868C6.04179 10.9402 5.84074 11.0312 5.64514 10.9901C5.44953 10.9491 5.33344 10.7914 5.38585 10.6381L5.71525 9.6741C5.00015 9.508 4.34302 9.24394 3.75919 8.90204L2.83299 9.62822C2.6898 9.74044 2.45764 9.74044 2.31445 9.62822C2.17126 9.51593 2.17126 9.33391 2.31445 9.22165L3.1952 8.53114C2.76033 8.21113 2.37775 7.84374 2.05578 7.43986C1.94846 7.30523 2.00066 7.12788 2.17238 7.04374C2.3441 6.95959 2.57032 7.00052 2.67764 7.13515C3.02926 7.57623 3.4586 7.96629 3.95238 8.28947C3.96031 8.29422 3.96805 8.29926 3.97558 8.30458C4.93991 8.92913 6.14727 9.29976 7.50001 9.29976C9.55906 9.29976 11.2814 8.44103 12.3224 7.13515C12.4297 7.00052 12.6559 6.95959 12.8276 7.04374Z"
      fill="#8692A6"
    />
  </svg>
</template>

<script>
export default {
  name: 'ClosedEyeIcon'
};
</script>

<style scoped>

</style>
